import WithGASetup from '../WithGASetup';
import TokenUsed from './TokenUsed';

export default WithGASetup(TokenUsed);
